import { CalendarItemType } from '$tablet-app/src/app/models';

/**
 * Query mapping between calendar item type and API query keys for easy invalidation of cache based on
 * calendar item type
 */
export const apiQueryKeys: Record<CalendarItemType, string> = {
  Alarm: 'alarms',
  Alert: 'alerts',
  Event: 'events',
  Meal: 'meals',
};
